module.exports = __webpack_public_path__ + "static/media/close.2823fc4f.svg";